import React from "react";
import compareVersions, {
    VERSION_CM_13766_SHARES_V3,
    VERSION_CM_8075_SHARE_REQUEST,
    VERSION_CM_8742_ASSET_SHARE_REQUEST,
} from "@cores/version";
import ButtonOutlineDark from "@components/buttons/ButtonOutlineDark";
import { Trans, useTranslation } from "react-i18next";
import VersionedComponent from "@components/VersionedComponent";
import { PROPERTY_PANEL_TYPE } from "@constants";
import { useSelector } from "react-redux";
import useCheckPermission from "@hooks/useCheckPermission";
import { IconOpenInBrowser } from "@mzc-cloudplex/icons";

const PanelPermissionError = (props) => {
    const { t } = useTranslation();
    const { handleShareRequestModal } = props;

    const { propertyPanel, stage } = useSelector(({ propertyPanel, stage }) => ({
        propertyPanel,
        stage,
    }));

    const SHARES_PERMISSIONS = useCheckPermission({ scope: "Project", domain: "Shares" });

    return (
        <div className={"box-permission"}>
            <div>
                <i className="sprite sprite-error-permission" />
            </div>
            <div>
                <strong className={"text-large"}>{t(`common::msg::You need access`)}</strong>
                <p>
                    <span>
                        <Trans
                            i18nKey="common::msg::If you want to check the assets you have selected, <0/> please ask for access."
                            components={[<br key="br" />]}
                        />
                    </span>
                </p>
            </div>
            {compareVersions(stage.version, VERSION_CM_13766_SHARES_V3) < 0 &&
                propertyPanel.type === PROPERTY_PANEL_TYPE.STORAGE && (
                    <VersionedComponent version={VERSION_CM_8075_SHARE_REQUEST}>
                        <ButtonOutlineDark
                            onClick={handleShareRequestModal}
                            disabled={!SHARES_PERMISSIONS.INTERNALREQUEST}
                        >
                            <span>{t(`common::label::${"Share Request"}`)}</span>
                            <IconOpenInBrowser size={16} />
                        </ButtonOutlineDark>
                    </VersionedComponent>
                )}
            {compareVersions(stage.version, VERSION_CM_13766_SHARES_V3) < 0 &&
                propertyPanel.type === PROPERTY_PANEL_TYPE.ASSET && (
                    <VersionedComponent version={VERSION_CM_8742_ASSET_SHARE_REQUEST}>
                        <ButtonOutlineDark
                            onClick={handleShareRequestModal}
                            disabled={!SHARES_PERMISSIONS.INTERNALREQUEST}
                        >
                            <span>{t(`common::label::${"Share Request"}`)}</span>
                            <IconOpenInBrowser size={16} />
                        </ButtonOutlineDark>
                    </VersionedComponent>
                )}
        </div>
    );
};
export default PanelPermissionError;
